import { render, staticRenderFns } from "./ScriptExecuteTriggerBehaviorEditorFromScriptlink.vue?vue&type=template&id=4b70afc4&scoped=true&"
import script from "./ScriptExecuteTriggerBehaviorEditorFromScriptlink.vue?vue&type=script&lang=ts&"
export * from "./ScriptExecuteTriggerBehaviorEditorFromScriptlink.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptExecuteTriggerBehaviorEditorFromScriptlink.vue?vue&type=style&index=0&id=4b70afc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70afc4",
  null
  
)

export default component.exports